<template>
    <v-layout align-center justify-center>
        <v-card width="700">
          <v-card-title class="headline grey lighten-2" primary-title>
            Please select a reason why you want to skip description <br />for
            item {{ SKU }}
          </v-card-title>
          <v-card-text>
            <v-radio-group>
              <v-radio
                v-for="itm in boxLocations"
                :key="itm.locationCode"
                :label="itm.type"
                :value="itm"
                on-icon="mdi-arrow-right"
                @change="setSkipReason(itm)"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="skipReason === ''"
              color="#66BB6A"
              @click="afterSkipSelected"
            >
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
</template>

<script>
export default {
  name: "SkipReasonsCard",
  props: {
    SKU: String,
    boxLocations: Array,
    skipReason: String,
  },
  methods: {
    setSkipReason(val) {
      this.$emit("setSkipReason", val);
    },
    afterSkipSelected() {
      this.$emit("afterSkipSelected");
    },
  },
};
</script>